import { render } from "./BaseRequiredSelectAutocomplete.vue?vue&type=template&id=c6af6c88"
import script from "./BaseRequiredSelectAutocomplete.vue?vue&type=script&lang=js"
export * from "./BaseRequiredSelectAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__